export const COMPANY_INFO = {
  name: 'ONS METTLE',
  tagline: 'Telecommunications Engineering',
  description: 'With over 10 years of specialized expertise in telecommunications components, we engineer precision solutions that power global network infrastructure and connectivity systems.',
  logo: '/OnsLogo.png',
  
  contact: {
    email: 'hello@onsmettle.com',
    phone: '+91 (555) 123-4567',
    locations: ['Indore', 'Madhya Pradesh, India']
  },
  
  social: [
    { name: 'LinkedIn', shortName: 'Li', href: '#' },
    { name: 'Twitter', shortName: 'Tw', href: '#' },
    { name: 'Facebook', shortName: 'Fb', href: '#' }
  ],
  
  stats: {
    yearsExperience: 10,
    governmentProjects: 3,
    successRate: 98,
    endToEndSolutions: 100
  }
};

export const NAVIGATION_ITEMS = [
  { name: 'Home', path: '/homepage', icon: 'Home' },
  { name: 'Services', path: '/services-overview', icon: 'Radio' },
  { name: 'Projects', path: '/featured-projects', icon: 'Network' },
  { name: 'Insights', path: '/insights-blog', icon: 'BookOpen' },
  { name: 'Careers', path: '/careers-hub', icon: 'Users' },
  { name: 'Contact', path: '/contact-engagement', icon: 'Antenna' },
  { name: 'About Us', path: '/about-us', icon: 'Info' }
];

export const SERVICE_LINKS = [
  { name: 'Engineering Solutions', href: '/services-overview' },
  { name: 'Technology Innovation', href: '/services-overview' },
  { name: 'Telecommunications', href: '/services-overview' },
  { name: 'Infrastructure Design', href: '/services-overview' }
];

export const LEGAL_LINKS = [
  { name: 'Privacy Policy', href: '#' },
  { name: 'Terms of Service', href: '#' },
  { name: 'Cookie Policy', href: '#' }
];

export const CORE_VALUES = [
  {
    title: 'Customer-Centricity',
    description: 'Placing our clients at the heart of everything we do, ensuring their success drives our innovation and service excellence.',
    icon: '🎯'
  },
  {
    title: 'Innovation',
    description: 'Embracing cutting-edge technology and creative solutions to solve complex engineering and telecommunications challenges.',
    icon: '🚀'
  },
  {
    title: 'Trust',
    description: 'Building lasting relationships through transparency, reliability, and consistent delivery of our commitments.',
    icon: '🤝'
  },
  {
    title: 'Engineering Excellence',
    description: 'Delivering superior technical solutions with precision, quality, and attention to detail in every project.',
    icon: '⚙️'
  }
];

export const INDUSTRY_EXPERTISE = [
  {
    title: 'Engineering',
    description: 'Deep technical expertise in design, development, and implementation of complex engineering solutions.',
    icon: '🔧',
    color: 'text-brand-cyan'
  },
  {
    title: 'Telecommunications',
    description: 'Comprehensive knowledge in telecom infrastructure, network design, and communication systems.',
    icon: '📡',
    color: 'text-brand-green'
  },
  {
    title: 'Project Management',
    description: 'Proven methodology with dedicated Project Heads and Managers ensuring successful delivery.',
    icon: '📋',
    color: 'text-brand-orange'
  },
  {
    title: 'Government Solutions',
    description: 'Specialized experience in delivering large-scale government and public sector projects.',
    icon: '🏛️',
    color: 'text-brand-purple'
  }
];